import React from "react";
import {Link} from "react-router-dom";
import { FacebookIcon } from "./svg/facebook-icon";
import { LinkedinIcon } from "./svg/linkedin-icon";

const menus = [
    {
        title: 'About',
        menuItems: [
            {
                label: 'Homepage',
                link: "/",
                target: "_self"
            },
            {
                label: 'Why PMG?',
                link: '/about',
                target: "_self"
            },
            {
                label: 'Case Studies',
                link: '/portfolio',
                target: "_self"
            },
        ]
    },
    {
        title: 'Resources',
        menuItems: [
            {
                label: 'Services',
                link: "/services",
                target: "_self"
            },
            {
                label: 'Pricing',
                link: '/pricing',
                target: "_self"
            },
            {
                label: 'Client Portal',
                link: 'https://portal.partneredmg.com',
                target: "_blank"
            }
        ]
    },
    {
        title: 'Help',
        menuItems: [
            {
                label: 'Privacy Policy',
                link: "/terms-and-privacy-policy#privacy-policy",
                target: "_self"
            },
            {
                label: 'Careers',
                link: "/careers",
                target: "_self"
            },
            {
                label: 'Report A Bug',
                link: 'https://forms.clickup.com/14342969/f/dnptt-1504/SKODMWOWC2OI07C0A5',
                target: "_blank"
            }
        ]
    }
]

class Footer extends React.Component {
    render() {
        return (
            <footer className="text-black20">
            <div className="bg-gradientBorder w-full h-[1px]"></div>
                <div className="container mx-auto flex flex-wrap flex-row justify-between items-start py-20 px-6">
                   
                    {menus.map((menu) => (
                        <div key={menu.title} className="flex w-full md:w-auto text-center md:text-left flex-col gap-6 py-6 items-start justify-center">
                            <h4 className="text-sm font-semibold w-full">{menu.title}</h4>
                            <ul className="flex flex-col gap-3 w-full items-center md:items-start justify-center  md:justify-start">
                                {menu.menuItems.map((item) => (
                                    <li key={item.label} className="text-sm font-normal">
                                        <Link to={item.link} target={item.target}>{item.label}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                    <div className="flex flex-col gap-6 py-6 items-start justify-center w-full md:w-auto">
                        <h4 className="text-sm font-semibold w-full text-center md:text-left">Follow Us</h4>
                        <div className="flex flex-row justify-center items-center gap-2 w-full md:w-auto">
                            <a href="https://www.facebook.com/PartneredManagementGroup" target="_blank" rel="noreferrer" aria-label="Partnered Management Group on Facebook">
                                <FacebookIcon />
                            </a>
                            <a href="https://www.linkedin.com/company/partneredmg" target="_blank" rel="noreferrer" aria-label="Partnered Management Group on LinkedIn">
                                <LinkedinIcon />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="bg-gradientBorder w-full h-[1px]"></div>
                <div className="pb-6 pt-4 text-center flex flex-col gap-1 items-center">
                    <p className="font-normal text-xs pointer-events-none">© Partnered Management Group - 2026</p>
                    <p className="font-normal text-xs pointer-events-none text-grey45">Charlotte, NC &nbsp;|&nbsp; <a href="mailto:support@partneredmg.com" className="pointer-events-auto hover:underline">support@partneredmg.com</a></p>
                </div>
            </footer>
        );
    };
};

export default Footer;